import React from 'react';
import './PrivacyModel.css';

const PrivacyModel = ({ show, onClose }) => {
  if (!show) return null;

  return (
    <div className="privacy-model-overlay" onClick={onClose}>
      <div className="privacy-model-content" onClick={(e) => e.stopPropagation()}>
        <div className="privacy-model-header">
          <h2>Privacy Policy</h2>
          <button className="privacy-model-close" onClick={onClose}>
            ×
          </button>
        </div>
        
        <div className="privacy-model-body">
          <div className="privacy-section">
            <h3>1. Information We Collect</h3>
            <p>We collect the following information:</p>
            <ul>
              <li>Email address or Mobile number (for login and user identification)</li>
              <li>Resume data voluntarily submitted during resume creation</li>
              <li>Cover letter data voluntarily submitted during cover letter creation</li>
              <li>Payment confirmation (not stored on our servers)</li>
              <li>Mandatory information required for user profile creation</li>
            </ul>
          </div>

          <div className="privacy-section">
            <h3>2. Use of Your Information</h3>
            <p>Your information is used to:</p>
            <ul>
              <li>Authenticate your identity during login (via email, mobile OTP, or google accounts)</li>
              <li>Manage your user account and provide personalized access</li>
              <li>Track purchase history and subscription status</li>
              <li>Offer features such as detailed ATS report, AI career toolkit, AI career map, Cover letter builder and downloads</li>
            </ul>
          </div>

          <div className="privacy-section">
            <h3>3. Resume Storage</h3>
            <p>Resumes are stored within each user's profile and remain available for a limited period, based on the pricing package selected. Users may use that resumes to switch templates or update any details within this period.</p>
            <p>To help improve the speed and efficiency of our AI services, we may temporarily store and reuse certain AI-generated outputs (such as ATS score check or ATS report) when similar requests are made by other users. Please note that these stored outputs contain no personal or identifiable information and are intended only to enhance performance and reduce repetitive processing.</p>
          </div>

          <div className="privacy-section">
            <h3>4. Sharing of Information</h3>
            <p>We do not sell or rent your data. Certain data may be shared with verified third-party service providers solely to operate essential platform services such as authentication, document generation, hosting, and payments.</p>
          </div>

          <div className="privacy-section">
            <h3>5. Cookies & Tracking</h3>
            <p>Basic tracking may be used for:</p>
            <ul>
              <li>Session management</li>
              <li>Platform improvement</li>
              <li>No third-party advertising cookies are used</li>
            </ul>
            <p>We do not use advertising or tracking cookies across our resume-building or user dashboard modules. However, our blog section may display ads, which may involve basic cookie-based personalization.</p>
          </div>

          <div className="privacy-section">
            <h3>6. Data Security</h3>
            <p>We implement reasonable technical and organizational measures to protect your personal information, including:</p>
            <ul>
              <li>Encrypted data transmission (HTTPS)</li>
              <li>Secure third-party payment and authentication providers</li>
              <li>Restricted access to user data</li>
            </ul>
            <p>While we follow industry-standard security practices, no method of online transmission or storage can be guaranteed to be completely secure.</p>
          </div>

          <div className="privacy-section">
            <h3>7. Your Rights</h3>
            <p>You may request deletion of your account and associated data by contacting us. After the expiration of your plan, resume data may be removed automatically. To request deletion or access, please email <strong>support@resumeglobe.com</strong>.</p>
          </div>

          <div className="privacy-section">
            <h3>8. Children's Privacy</h3>
            <p>This platform is not intended for individuals under the age of 13. We do not knowingly collect data from children. If we become aware that data from a child under 13 has been collected, we will delete it promptly.</p>
          </div>

          <div className="privacy-section">
            <h3>9. Changes to This Policy</h3>
            <p>We reserve the right to revise this Privacy Policy. Any updates will be posted on our platform, and continued use indicates acceptance of those changes.</p>
          </div>

          <div className="privacy-section">
            <h3>10. Contact</h3>
            <p>For privacy concerns or requests, please email us at <strong>support@resumeglobe.com</strong>.</p>
            <p><strong>Last Updated: Aug 10, 2025.</strong></p>
          </div>
        </div>
        
        <div className="modal-footer">
          <button className="btn-close-modal" onClick={onClose}>Close</button>
        </div>
      </div>
    </div>
  );
};

export default PrivacyModel;